<template>
    <div>
        <loading :active.sync="isLoading"
                 :can-cancel="true"
                 :is-full-page="true">
        </loading>
        <div class="form_row" v-if="this.update_order > 0">
            <label class="order__input-label">Код скидки</label>
            <cart-promo></cart-promo>
        </div>
        <div class="form-group">
            <label class="order__input-label">{{ this.manager_title }}</label>
            <div>
                <select @change="setSpecData" class="order__input" v-model="sys_manager">
                    <option v-for="(manager,key) in this.managers_arr" :value="key">{{ manager }}</option>
                </select>
            </div>
        </div>
        <div v-if="!this.isrepair" class="form_row">
            <label class="order__input-label">способ оформления заказа:</label>
            <select @change="setSpecData" class="order__input" v-model="make_order_method">
                <option v-for="(method,key) in this.order_methodsLocal" :value="key">{{ method }}</option>
            </select>
        </div>

        <div class="form_row" v-if="this.isrepair">
            <label class="order__input-label">Артикул модели сдаваемой в ремонт: {{ repair_model }}</label>
            <input type="text" class="order__input" v-model="searchTerm" />
            <button class="btn btn--blue card4__btn" @click.prevent="searchProduct()">Найти</button>
            <div class="form-group">
                <select class="order__input" v-model="repair_model" @change="this.setSpecData" v-if="this.foundProducts.length">
                    <option value="0">---</option>
                    <option v-for="(product, key) in this.foundProducts" :value="product.article">{{ product.label }}</option>
                </select>
            </div>
            <div class="text-danger">{{ this.repair_article_message }}</div>

            <div v-if="this.client_orders.length !== 0">
                <label class="order__input-label">Заказ:</label>
                <select class="order__input" v-model="client_order_selected" @change="setPurchaseDate()">
                    <option value="---">---</option>
                    <option v-for="(order, key) in this.client_orders" :value="key">{{ order }}</option>
                </select>
            </div>

        </div>
        <div class="form_row" v-if="this.isrepair">
            <label class="order__input-label">Дата покупки товара:</label>
            <datepicker @change="setSpecData" class="order__input" name="repair_purchase_date" v-model="repair_purchase_date"></datepicker>
        </div>
        <div class="form_row" v-if="this.isrepair">
            <label class="order__input-label">Комплектация и состояние:</label>
            <textarea  @change="setSpecData" class="order__input" name="compl_and_state" v-model="compl_and_state"></textarea>
        </div>
        <div class="form_row" v-if="this.isrepair">
            <label class="order__input-label">Заявленные повреждения и причина со слов клиента:</label>
            <textarea  @change="setSpecData" class="order__input" name="repair_addinfo" v-model="repair_addinfo"></textarea>
        </div>
        <div class="form_row" v-if="this.isrepair">
            <label class="order__input-label">Вид ремонта:</label>
            <select @change="setSpecData" class="order__input" name="repair_type" v-model="repair_type">
                <option v-for="(r_type, key) in this.repair_typesLocal" :value="key">{{ r_type }}</option>
            </select>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'
    import CartPromo from './cart-promo.vue'

    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: "cart-remont",
        components: {
            Datepicker,
            Loading,
            CartPromo
        },
        props: {
            is_repair_order: Number,
            service_product_id: Number,
            repair_types: Array,
            managers: Object,
            masters: Object,
            order_methods: Object,
        },
        data () {
            return {
                service_product_idLocal: this.service_product_id,
                update_order: 0,
                repair_article: '',
                repair_model: '',
                compl_and_state: '',
                repair_addinfo: '',
                repair_type: 0,
                repair_typesLocal: this.repair_types,
                managersLocal: this.managers,
                mastersLocal: this.masters,
                repair_purchase_date: '',
                sys_on_order: '',
                sys_manager: 0,
                make_order_method: '',
                order_methodsLocal: this.order_methods,
                searchTerm: '',
                foundProducts: [],
                repair_article_message: '',
                client_orders: [],
                client_order_selected: '',
                order_message: '',
                switch_to: 0,
            }
        },
        methods: {
            searchProduct () {
                this.$store.commit('clearError')
                this.$store.commit('setLoading', true)
                try {
                    let params = new URLSearchParams();
                    params.append('action', 'find_product');
                    params.append('term', this.searchTerm);
                    axios
                        .get('/rest/spec', {params})
                        .then((response) => {

                            let data = JSON.parse(response.data);
                            this.foundProducts = data;
                            this.searchTerm = '';
                            this.$store.commit('setLoading', false)
                        })
                } catch(error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                }
            },
            refreshSpecData () {
                this.$store.commit('clearError')
                this.$store.commit('setLoading', true)
                try {
                    let params = new URLSearchParams();
                    params.append('action', 'get_spec_data');
                    axios
                        .get('/rest/spec', {params})
                        .then((response) => {

                            let data = JSON.parse(response.data);
                            this.repair_article = data.repair_article
                            this.compl_and_state = data.repair_compl_and_state
                            this.repair_addinfo = data.repair_addinfo
                            this.repair_type = data.repair_type
                            this.repair_model = data.repair_article
                            this.repair_purchase_date = data.repair_purchase_date
                            this.sys_manager = data.sys_manager
                            this.update_order = data.update_order
                            this.make_order_method = data.make_order_method
                            this.sys_on_order = data.sys_on_order

                            this.$store.commit('setLoading', false)
                        })
                } catch(error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                }
            },
            setSpecData()
            {
                let params = new URLSearchParams();
                params.append('action', 'set_spec_data')
                params.append('repair_type', this.repair_type)
                params.append('repair_addinfo', this.repair_addinfo)
                params.append('repair_compl_and_state', this.compl_and_state)
                params.append('repair_purchase_date', this.repair_purchase_date)
                params.append('repair_article', this.repair_model)
                params.append('sys_manager', this.sys_manager)
                params.append('make_order_method', this.make_order_method)

                let param = yii.getCsrfParam();
                let token = yii.getCsrfToken();
                params.append(param, token)

                axios
                    .put('/rest/spec', params)
                    .then((response) => {
                        if(this.repair_model !== '') {
                            this.checkRepairArticle()
                        }
                        this.$store.commit('setLoading', false)
                    }).catch(error => {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                })
            },
            checkRepairArticle() {
                this.$store.commit('clearError')
                this.$store.commit('setLoading', true)
                try {
                    let params = new URLSearchParams();
                    params.append('action', 'check_repair_article');
                    params.append('repair_article', this.repair_model)
                    axios
                        .get('/rest/spec', {params})
                        .then((response) => {

                            let data = JSON.parse(response.data);

                            this.repair_article_message = data.error
                            this.client_orders = data.orders

                            this.$store.commit('setLoading', false)
                        })
                } catch(error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error.message)
                    throw error
                }
            },
            setPurchaseDate () {
                this.repair_purchase_date = this.client_order_selected
                this.setSpecData()
            }
        },
        computed: {
            manager_title() {
                return (this.isrepair) ? 'Мастер' : 'Менеджер';
            },
            managers_arr () {
                return (this.isrepair) ? this.mastersLocal : this.managersLocal;
            },
            isLoading() {
                return this.$store.getters.loading;
            },
            isrepair () {
                const cart_items = this.$store.getters.cartitems;
                let product = cart_items.filter((item) => {
                    return item.product_id==this.service_product_idLocal;
                });

                if(typeof product[0] !== 'undefined') {
                    return true;
                }

                return false;
            }
        },
        mounted() {
            this.refreshSpecData();
        }
    }
</script>

<style scoped>

</style>
